export default __webpack_public_path__ + "static/media/morning-small-min.b772790e.jpg";